<template>
  <div id="page-wrapper">
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ $t('vpn.title') }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
          <li class="breadcrumb-item active">{{ $t('vpn.title') }}</li>
        </ol>
      </div>
    </div>
    <div class="container-fluid">
      <!-- /row -->
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="pull-left">
                <el-popconfirm v-if="userRole == 1"
                  :confirmButtonText="$t('reimbursement.ok')"
                  :cancelButtonText="$t('leave.cancel')"
                  icon="el-icon-info"
                  iconColor="red"
                  :title="$t('vpn.approve-confirm')"
                  @confirm="approveSelectedItems"
                >
                  <el-button slot="reference" size="small">{{ $t('vpn.approve') }}</el-button>
                </el-popconfirm>
                <el-popconfirm v-if="userRole == 1"
                  :confirmButtonText="$t('reimbursement.ok')"
                  :cancelButtonText="$t('leave.cancel')"
                  icon="el-icon-info"
                  iconColor="red"
                  :title="$t('vpn.approve-confirm')"
                  @confirm="declineSelectedItems"
                  style="margin-left:5px"
                >
                  <el-button slot="reference" size="small">{{ $t('vpn.decline') }}</el-button>
                </el-popconfirm>
                <el-button type="primary" size="small" @click="applyVPN" style="margin-left:5px">{{ $t('vpn.apply') }}</el-button>
              </div>
              <!--<h4>
                {{ $t('vpn.title') }}
              </h4>-->
            </div>
            <div class="card-body">
              <el-table
                ref="my-vpn-list"
                :data="vpnList"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  prop="name"
                  :label="$t('vpn.user')"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="practiceId"
                  :label="$t('vpn.practice')"
                  width="120">
                  <template slot-scope="scope">
                    {{ getPractice(scope.row.practiceId) }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="title"
                  :label="$t('vpn.title2')"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="applyReason"
                  :label="$t('vpn.reason')"
                  width="120">
                  <template slot-scope="scope">
                    {{ getVpnReason(scope.row.applyReason) }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="startDate"
                  :label="$t('vpn.start-date')"
                  width="220">
                  <template slot-scope="scope">
                    {{ scope.row.startDate + ' - ' + scope.row.endDate }}
                  </template>
                </el-table-column>
                
                <el-table-column
                  prop="appliedTime"
                  :label="$t('vpn.applied-time')"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="status"
                  :label="$t('vpn.status')"
                  width="120">
                  <template slot-scope="scope">
                    {{ getLeaveStatus(scope.row.status) }}
                  </template>
                </el-table-column>
                
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <el-dialog :title="$t('vpn.title1')" 
      :visible.sync="applyForm"
      width="70%"
      top="30px"
      :append-to-body="true">
            <VPNForm ref="requestForm" @value-save="serviceApplied" />
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="applyService">{{ $t('vpn.apply') }}</el-button>
          <el-button @click="applyForm = false">{{ $t('vpn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// @ is an alias to /src
import VPNForm from '@/components/admin/VPNForm.vue'

export default {
  name: 'VPNList',
  components: {
    VPNForm
  },
  data: function() {
  return {
    activeTab: '1',
    vpnList: [],
    selectedItems: [],
    applyForm: false
  }
  },
  watch: {
  },
  computed: {
    userRole: function() {
      return localStorage.getItem('role')
    }
  },
  methods: {
    approveSelectedItems: function() {
      let data = this.selectedItems,
          d = {
            'ids': [],
            'status': 1,
            'type': 'vpn',
            'oldStatus': 0
          },
          that = this
        data.forEach(function(v, i) {
          if (v.status == 0)
            d['ids'].push(v.id)
        })
          this.$http.post(this.API3_PREFIX + 'status', d).then(function (response) {
            that.$message({
              message: that.$t('vpn.approve-success'),
              type: 'success'
            })
            //change status for original data
            data.forEach(function(v, i) {
              v.status = 1
              v.statusName = that.getLeaveStatus(v.status)
            })
          }).catch(function (error) {
            console.log(error)
            that.$message({
              message: that.$t('vpn.approve-failed'),
              type: 'error'
            })
          })
    },
    declineSelectedItems: function() {
      let data = this.selectedItems,
          d = {
            'ids': [],
            'status': 2,
            'type': 'vpn',
            'oldStatus': 0
          },
          that = this
      data.forEach(function(v, i) {
        if (v.status == 0)
          d['ids'].push(v.id)
      })
      this.$http.post(this.API3_PREFIX + 'status', d).then(function (response) {
          that.$message({
            message: that.$t('vpn.decline-success'),
            type: 'success'
          })
          //change status for original data
          data.forEach(function(v, i) {
            v.status = 2
            v.statusName = that.getLeaveStatus(v.status)
          })
        }).catch(function (error) {
          console.log(error)
          that.$message({
            message: that.$t('vpn.decline-failed'),
            type: 'error'
          })
        })
    },
    handleSelectionChange: function(val) {
      //console.log(val)
      this.selectedItems = val
    },
    serviceApplied: function(val) {
      //update data
      console.log(val)
      this.applyForm = false
    },
    applyService: function() {
      this.$refs.requestForm.createRequest()
    },
    applyVPN: function() {
      this.applyForm = true
    },
    loadData: function() {
      let that = this

    this.$http.get(this.API3_PREFIX + 'vpn/' + localStorage.getItem('token')).then(function (response) {
    that.vpnList = response.data
      }).catch(function (error) {
    console.log(error)
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>